import { DropdownValuesResponseDto } from '../models/dto/dropdown-values-response.dto';
import { DropdownEntitiesEnum } from '../enums';
import { IDropdownEntity } from '../interfaces/dropdown-entity.interface';

export function getDropdownValues(entity: DropdownEntitiesEnum, values?: DropdownValuesResponseDto[]): IDropdownEntity[] {
	return values?.find(x => x.dropdownEntity === entity)?.values || [];
}
